var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var IndexAccess = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return concat([path.call(_print, 'base'), '[', path.call(_print, 'index'), ']']);
  }
};
module.exports = IndexAccess;